// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCv3IXjKAnW2iXk3Rzd-VdLIdnlpRb0kxQ",
  authDomain: "cbwc-5558c.firebaseapp.com",
  projectId: "cbwc-5558c",
  storageBucket: "cbwc-5558c.firebasestorage.app",
  messagingSenderId: "190103906140",
  appId: "1:190103906140:web:b1bb7c3a3b3d119c2c4399",
  measurementId: "G-8S0JPTJ9E4",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);
